<template>
    <el-card 
    header="word-view"
    >
        <div class="frame-con">
            <word-view
                src="http://www.hbidding.com/otc/static/agency/files/%E6%97%A0%E6%8E%A8%E9%80%81-%E7%9C%9F%E5%AE%9E%E6%80%A7%E5%A3%B0%E6%98%8E.docx"
            ></word-view>
        </div>
    </el-card>
</template>

<script>
export default {
    props: [],
    data () {
        return {
            
        }
    },
    methods: {
        
    },
    mounted: function() {
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .frame-con{width:100%; height:500px; position:relative;}
</style>
